import { render, staticRenderFns } from "./NewsTec.vue?vue&type=template&id=36d3ec2a&scoped=true"
import script from "./NewsTec.vue?vue&type=script&lang=js"
export * from "./NewsTec.vue?vue&type=script&lang=js"
import style0 from "./NewsTec.vue?vue&type=style&index=0&id=36d3ec2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3ec2a",
  null
  
)

export default component.exports